import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';

const MyClub = () => {
  const navigate = useNavigate();

  // Redirect to dashboard since we no longer need the detail page
  useEffect(() => {
    navigate('/dashboard', { replace: true });
  }, [navigate]);

  // Show loading while redirecting
  return (
    <Container fluid style={{ marginTop: '20px' }}>
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-muted">Redirecting to dashboard...</p>
        </div>
      </div>
    </Container>
  );
};

export default MyClub; 